module.exports = __webpack_public_path__ + "static/media/tnimage.26b43131.png";